(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderOverlayState extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('header-wrapper--overlay')) return;
      this.updateOverlayScroll = () => {
        this.classList.toggle('header-wrapper--scrolled', window.scrollY > 10);
      };
      this.updateOverlayScroll();
      window.addEventListener('scroll', this.updateOverlayScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.updateOverlayScroll) window.removeEventListener('scroll', this.updateOverlayScroll);
    }
  }

  class OverlayHeader extends HeaderOverlayState {
    connectedCallback() {
      super.connectedCallback();
      const headerScroll = document.querySelector('.shopify-section-group-header-group.section-ticker-slider-infinity');
      const headerFirstScroll = document.querySelector('#MainContent .section-image-banner+.section-ticker-slider-infinity');
      const header = this.closest('.shopify-section.section-header');
      const updateHeight = () => {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
        document.documentElement.style.setProperty('--headerscroll-height', `${headerScroll.offsetHeight}px`);
        document.documentElement.style.setProperty('--sectionfirstscroll-height', `${headerFirstScroll.offsetHeight}px`);
      };
      updateHeight();
      this.resizeObserver = new ResizeObserver(updateHeight);
      this.resizeObserver.observe(header, { box: 'border-box' });
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.resizeObserver.disconnect();
    }
  }

  customElements.define('overlay-header', OverlayHeader);

  class StickyHeader extends HeaderOverlayState {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      super.connectedCallback();
      this.headerScroll = document.querySelector('.shopify-section-group-header-group.section-ticker-slider-infinity');
      this.sectionFirstScroll = document.querySelector('#MainContent .section-image-banner+.section-ticker-slider-infinity');
      this.header = this.closest('.shopify-section.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.setHeaderHeight();

      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header, { box: 'border-box' });

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--headerscroll-height', `${this.headerScroll.offsetHeight}px`);
      document.documentElement.style.setProperty('--sectionfirstscroll-height', `${this.sectionFirstScroll.offsetHeight}px`);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.resizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const account = event.target;
      const headerWrapper = account.closest('.header-wrapper');
      const bottom = Math.max(0, Math.round(account.getBoundingClientRect().bottom));

      account.style.setProperty('--account-dialog-top', `${bottom}px`);
      headerWrapper?.classList.add('header-wrapper--account-open');
    },
    true
  );

  document.addEventListener(
    'close',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      event.target.closest('.header-wrapper')?.classList.remove('header-wrapper--account-open');
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
